import React from "react";
export { default as Alert } from "react-bootstrap/lib/Alert";
export { default as Badge } from "react-bootstrap/lib/Badge";
export { default as Button } from "react-bootstrap/lib/Button";
export { default as ButtonGroup } from "react-bootstrap/lib/ButtonGroup";
export { default as Breadcrumb } from "react-bootstrap/lib/Breadcrumb";
export { default as Navbar } from "react-bootstrap/lib/Navbar";
export { default as NavItem } from "react-bootstrap/lib/NavItem";
export { default as Nav } from "react-bootstrap/lib/Nav";
export { default as Checkbox } from "react-bootstrap/lib/Checkbox";
export { default as Modal } from "react-bootstrap/lib/Modal";
export { default as Pager } from "react-bootstrap/lib/Pager";

import ButtonGroup from "react-bootstrap/lib/ButtonGroup";
import Button from "react-bootstrap/lib/Button";

export const ToggleOption = ({
    onClick = () => {},
    disabled = false,
    value
}) => <ButtonGroup>
    <Button
        disabled={disabled}
        onClick={() => onClick(true)}
        className={value ? "btn-primary" : null}
        type="button">Yes</Button>
    <Button
        disabled={disabled}
        onClick={() => onClick(false)}
        className={!value ? "btn-primary" : null}
        type="button">No</Button>
</ButtonGroup>